import { useState } from "react";
import SortImg from "assets/icons/sort.svg";
import "./style.scss";

export const CardTable = (props: any) => {
  const [checkStatus, setCheckStatus] = useState<boolean>(false);
  const checkAll = (status: any) => {
    setCheckStatus(status);
  };

  return (
    <section className="table-component">
      <table className="card_table">
        <thead>
          <tr className="table-component_head">
            <th className="card_table-th" scope="col">
              <div>
								<span>ACCOUNT NO</span>
								<img
									src={SortImg}
									alt="sort"
									className="card_table-th-sort"
								/>
							</div>
            </th>
            <th className="card_table-th" scope="col">
							<div>
								<span>OPEN DATE</span>
								<img
									src={SortImg}
									alt="sort"
									className="card_table-th-sort"
								/>
							</div>
            </th>
            <th className="card_table-th" scope="col">
							<div>
								<span>TIER STATUS</span>
								<img
									src={SortImg}
									alt="sort"
									className="card_table-th-sort"
								/>
							</div>
            </th>
            <th className="card_table-th" scope="col">
							<div>
								<span>CARD STATUS</span>
								<img
									src={SortImg}
									alt="sort"
									className="card_table-th-sort"
								/>
							</div>
            </th>
          </tr>
        </thead>
        <tbody>
          {props.cards &&
            props.cards.length > 0 &&
            props.cards.map((data?: any) => (
              <tr key={data.id}>
                <td
                  className={
                    data.id % 2 == 0
                      ? "card_table-td"
                      : "card_table-td-even"
                  }
                >
                  <span>{data.account_no}</span>
                </td>
                <td
                  className={
                    data.id % 2 == 0
                      ? "card_table-td"
                      : "card_table-td-even"
                  }
                >
                  <span>{data.open_date}</span>
                </td>
                <td
                  className={
                    data.id % 2 == 0
                      ? "card_table-td"
                      : "card_table-td-even"
                  }
                >
                  <span>{data.tier_status}</span>
                </td>
                <td
                  className={
                    data.id % 2 == 0
                      ? "card_table-td"
                      : "card_table-td-even"
                  }
                >
                  <span>{data.card_status}</span>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </section>
  );
};
